import template from './ellipsis.html';
import './ellipsis.global.css';

export const EllipsisComponent = {
  template,
};
